export default {"src":"/_next/static/media/sneakExplore.95874577.svg","height":382,"width":320};